<template>
  <div
    v-if="packages && $login.can('packages.view')"
    class="packages-list"
  >
    <page-header header="Packages">
      <template slot="suffix">
        <div class="d-inline-flex align-items-center justify-content-center number-indicator">
          {{ packages.length }}
        </div>
      </template>
      <router-link
        v-if="$login.can('packages.create')"
        v-loading="loading"
        :to="{ name: 'packages.create' }"
        class="ml-1 btn btn-primary "
      >
        Create New Package
      </router-link>
    </page-header>
    <div class="py-3">
      <search v-model="params.search" />
      <vue-good-table
        class="mt-3 border-top border-left border-right"
        :rows="packages"
        @on-row-click="({row}) => $router.replace({name: 'packages.edit', params: {packageId: row.id}})"
        :columns="[{label: 'Package', field: 'name'}]"
        styleClass="vgt-table"
      />

      <pagination
        :data="pagination"
        :disabled="loading"
        @change-page="(page) => { params.page = page }"
      />
    </div>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table'
import axios from '@/axios'
import {createHttpQuery} from '@/helpers'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'

const defaultPagination = () => {
  return {
    page: 1,
    search: null,
  }
}

export default {
  components: {
    VueGoodTable,
    Search,
    Pagination,
  },

  data () {
    return {
      packages: [],
      pagination: null,
      loading: false,
      params: defaultPagination(),
    }
  },

  metaInfo () {
    return {
      title: 'Packages',
    }
  },

  watch: {
    params: {
      deep: true,
      handler () {
        this.getPackages()
      },
    },
  },

  created () {
    this.getPackages()
  },

  methods: {
    async getPackages () {
      this.loading = true

      const params = createHttpQuery(this.params)
      const {data: packages} = await axios.get('/roles', {params})
      this.pagination = packages.meta
      this.packages = packages.data

      this.loading = false
    },

    onRowClick (pkg) {
      this.$router.push({name: 'packages.edit', params: {packageId: pkg.id}})
    },
  },
}
</script>

<style lang="scss">

.el-table {
  &__row {
    a {
      color: $black;
    }
  }
}
</style>
